import { permissions } from "./auth/config";

export interface Auth {
  required?: string[];
  oneOf?: string[];
}

export interface rbacItem {
  auth?: Auth;
  badge?: {
    variant: string;
    text: string;
  };
  children?: {};
  icon: string;
  name: string;
  url: string;
}

interface navConfig {
  items: rbacItem[];
}

const navItems: navConfig = {
  items: [
    {
      badge: {
        variant: "primary",
        text: ""
      },
      icon: "fa fa-bar-chart",
      name: "Dashboard",
      url: "/dashboard",
      auth: {
        oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
      }
    },
    {
      badge: {
        variant: "primary",
        text: ""
      },
      icon: "fa fa-line-chart",
      name: "BI & Analytics",
      url: "/analytics",
      auth: {
        oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
      },
      children: [
        {
          name: "Order Reports",
          url: "/analytics/orderReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        {
          name: "Payment Reports",
          url: "/analytics/paymentReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        // {
        //   icon:"fa fa-sitemap",
        //   name:"Item Reports",
        //   url:"/analytics/itemReport",
        //   auth: {
        //     oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
        //   }, 
        // },
        {
          name: "Partner Reports",
          url: "/analytics/partnerReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        // {
        //   icon:"fa fa-cube",
        //   name:"Refund Reports",
        //   url:"/analytics/refundReport",
        //   auth: {
        //     oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
        //   }, 
        // },
        {
          name: "Commission Reports",
          url: "/analytics/commissionReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        {
          name: "Service Request Reports",
          url: "/analytics/serviceRequestReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        // {
        //   icon:"fa fa-exchange",
        //   name:"Inventory Reports",
        //   url:"/analytics/inventoryReport",
        //   auth: {
        //     oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
        //   }, 
        // },
        // {
        //   icon:"fa fa-list-alt",
        //   name:"Invoice Reports",
        //   url:"/analytics/invoiceReport",
        //   auth: {
        //     oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
        //   }, 
        // },
        {
          name: "Delivery Charge Reports",
          url: "/analytics/deliveryChargeReport",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
        {
          name: "Daily Registration",
          url: "/analytics/dailyRegistration",
          auth: {
            oneOf: ["ADMIN_DASH", "TENANT_DASH", "PARTNER_DASH"]
          },
        },
      ],
    },

    {
      name: "Attribute",
      url: "/attribute",
      icon: "fa fa-cube",
      auth: permissions.attribute
    },
    {
      name: "Catalog",
      url: "/catalog",
      icon: "fa fa-calendar-minus-o",
      auth: permissions.catalog
    },
    {
      name: "Item",
      url: "/item",
      icon: "fa fa-sitemap",
      auth: permissions.item
    },
    {
      name: "Inventory",
      url: "/inventory",
      icon: "fa fa-exchange",
      auth: permissions.inventory
    },
    {
      name: "Tenant",
      icon: "fa fa-user-plus",
      url: "/tenant",
      auth: permissions.tenant
    },
    {
      name: "User Management",
      icon: "fa fa-address-card",
      url: "/user",
      auth: permissions.sub_tenant
    },
    {
      name: "Partner",
      url: "/partner",
      icon: "fa fa-handshake-o",
      auth: permissions.partner
    },
    {
      name: "Order Management",
      icon: "fa fa-shopping-cart",
      url: "/manage-orders",
      auth: permissions.orders_management
    },
    {
      badge: {
        variant: "primary",
        text: ""
      },
      icon: "fa fa-user",
      name: "Customer Management",
      url: "/customer-management",
      auth: {
        oneOf: ["TENANT_DASH"]
      }
    },
    {
      badge: {
        variant: "primary",
        text: ""
      },
      icon: "fa fa-user",
      name: "Project Manager",
      url: "/project-manager",
      auth: {
        oneOf: ["TENANT_DASH"]
      }
    },
    {
      name: "Manage Own Customer",
      icon: "fa fa-users",
      url: "/manage_own_customer",
      auth: permissions.manage_own_customer
    },
    {
      name: "Payment History",
      icon: "fa fa-history",
      url: "/payment-history",
      auth: permissions.payment_history
    },
    {
      name: "Office Management",
      icon: "fa fa-briefcase",
      url: "/office-management",
      auth: permissions.office_org
    },
    {
      name: "Stock Point",
      icon: "fa fa-building-o",
      url: "/suboffice-management",
      auth: permissions.suboffice_org
    },
    {
      name: "Approvals",
      icon: "fa fa-check",
      url: "/approvals",
      auth: permissions.approval
    },
    {
      name: "Bulk Promotion",
      icon: "fa fa-bullhorn",
      url: "/bulkPromotion",
      auth: {
        oneOf: ["TENANT_DASH"]
      }
    },
    // {
    //   name: "SubScription Assign",
    //   url: "/subcription-assign",
    //   icon: "fa fa-handshake-o",
    //   auth: permissions.partner
    // },
    {
      name: "Role",
      icon: "fa fa-graduation-cap",
      url: "/role",
      auth: permissions.role
    },
    {
      name: "Bulk Notification",
      icon: "fa fa-bell",
      url: "/listOfCriteria",
      auth: permissions.bulkNotification
    },
    { 
      name: "Notification Approval",
      icon: "fa fa-bell",
      url: "/approvalNotification",
      auth: permissions.approvalNotification
    },
    {
      url: "/notification-template",
      name: "Notification Template",
      icon: "fa fa-envelope",
      auth: permissions.templateCreation
    },
    {
      name: "Setup",
      icon: "fa fa-wrench",
      url: "/setup",
      auth: permissions.setup,
      children: [
        {
          name: "Resources",
          url: "/setup/Resources",
          auth: permissions.Resources
        },
        {
          name: "Concern",
          url: "/setup/concern",
          auth: permissions.concern
        },
        {
          name: "Faq",
          url: "/setup/faq",
          auth: permissions.FAQSetup
        },
        {
          name: "Tax Code",
          url: "/setup/taxcode",
          auth: permissions.taxcodeSetup
        },
        {
          name: "Coupon & Promotion",
          url: "/setup/Coupon",
          auth: permissions.couponSetup
        },
        {
          name: "Subscription Plan",
          url: "/setup/subscriptionplan",
          auth: permissions.subscription
        },
        {
          name: "Acces Rule",
          url: "/setup/accessrule",
          auth: permissions.accessrule
        },
        {
          name: "Delivery Setup",
          url: "/setup/deliverysetup",
          auth: permissions.deliverysetup
        },
        {
          url: "/setup/commission",
          name: "Commission Setup",
          auth: permissions.commissionSetup
        },
        {
          url: "/setup/service-request",
          name: "Service Request",
          auth: permissions.serviceRequestSetup
        },
      ]
    },
    {
      name: "Permission",
      icon: "fa fa-lock",
      url: "/permission",
      auth: permissions.permission
    },
    {
      name: "Advertisement",
      icon: "fa fa-bullhorn",
      url: "/advertisement",
      auth: permissions.advertisement
    },
    {
      name: "Commission",
      icon: "fa fa-percent",
      url: "/commission",
      auth: permissions.commission
    },
    {
      name: "Promotions",
      icon: "fa fa-bullhorn",
      url: "/promotions",
      auth: permissions.promotion
    },
    {
      name: "Customer",
      url: "/customer",
      icon: "fa fa-users",
      auth: permissions.customer
    },
    {
      name: "Service Ticket",
      icon: "fa fa-ticket",
      url: "/serviceticket",
      auth: permissions.setup,
      children: [
        {
          name: "Customer Open tickets",
          url: "/serviceticket/open",
          auth: permissions.setup
        },
        {
          name: "Customer Close tickets",
          url: "/serviceticket/close",
          auth: permissions.setup
        }
      ]
    },
    {
      name: "FAQS",
      icon: "fa fa-question-circle",
      url: "/faq",
      auth: permissions.faq
    }
    // {
    //   name: 'Service Request',
    //   icon: 'icon-puzzle',
    //   url: '/service-request',
    //   auth: permissions.serviceRequest,

    // },
    // {
    //   name: "Manage Team",
    //   icon: "fa fa-group",
    //   url: "/manage-team",
    //   auth: permissions.manage_team
    // },
    // {
    //   name: 'Offer-image',
    //   icon: 'fas fa-images',
    //   url: '/offerimage',
    //   auth: permissions.orders_management,
    // },
    // {
    //   name: 'Discount & Coupons',
    //   icon: 'fa fa-credit-card',
    //   url: '/discount-coupon',
    //   auth: permissions.discount_coupons,
    // },
  ]
};

export default navItems;
